import LetterRequest from '@/modules/letters/models/LetterRequest'
import List from '@/shared/dtos/List'
import { HttpService } from '@/shared/services'

const http = new HttpService()

export const getLettersGeneratedReports = async (companyId?: string) => {
  let url = '/letterRequests/reports/generated'
  if (companyId) {
    url += `?companyId=${companyId}`
  }

  const response = await http.get<List<LetterRequest[]>>(url)
  return response.data.data
}
